import { cn } from "@/lib/utils";

const tones = {
  cyan: "bg-cyan-400/10 text-cyan-300 ring-1 ring-cyan-300/25",
  emerald: "bg-emerald-400/10 text-emerald-300 ring-1 ring-emerald-300/25",
  amber: "bg-amber-400/10 text-amber-200 ring-1 ring-amber-300/25",
  rose: "bg-rose-400/10 text-rose-300 ring-1 ring-rose-300/25",
  ice: "bg-blue-400/10 text-blue-300 ring-1 ring-blue-300/25",
  neutral: "bg-white/5 text-white/80 ring-1 ring-white/10",
};

export function StatusPill({ tone = "neutral", className, children, ...rest }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium",
        tones[tone] || tones.neutral,
        className
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
